module.exports = __webpack_public_path__ + "img/dianpu.6b1e348e.png";